// src/components/layout/Preloader.jsx
import React from 'react'
import { motion } from 'framer-motion'

const Preloader = () => {
  return (
    <div className="fixed inset-0 bg-primary-black flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo agrandi - Taille augmentée */}
        <motion.div
  initial={{ scale: 0, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  transition={{ duration: 1.2 }}
  className="w-56 h-56 md:w-48 md:h-48 mx-auto mb-8 rounded-2xl overflow-hidden border-4 border-primary-gold shadow-2xl"
>
  <img 
    src="/assets/images/EsaieMusiclogo.jpg" 
    alt="Esaie Wilondja Logo" 
    className="w-full h-full object-cover"
  />
</motion.div>

        {/* Animation spirituelle légèrement réduite pour équilibrer */}
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 1.5, delay: 0.3 }}
          className="w-16 h-16 gold-gradient rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <span className="text-primary-black font-bold text-xl">✞</span>
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="text-4xl font-bold text-white mb-4 font-serif"
        >
          Esaie Wilondja
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.0 }}
          className="text-gray-400 text-lg mb-8"
        >
          Music Ministry
        </motion.p>

        {/* Barre de chargement */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "200px" }}
          transition={{ delay: 1.2, duration: 2 }}
          className="h-1 gold-gradient rounded-full mx-auto"
        />
      </div>
    </div>
  )
}

export default Preloader